import React from 'react';
interface EmptyStateProps {
  icon: string;
  title: string;
  subtitle: string;
}
export function EmptyState({
  icon,
  title,
  subtitle
}: EmptyStateProps) {
  return <div className="py-16 md:py-[100px] px-6 md:px-9 text-center animate-fade" data-id="element-24">
      <span className="text-[3.5rem] md:text-[4.5rem] block mb-3 md:mb-4 opacity-15 grayscale" data-id="element-25">
        {icon}
      </span>
      <div className="font-serif text-[1.1rem] md:text-[1.4rem] text-ink2 mb-2 font-bold" data-id="element-26">
        {title}
      </div>
      <div className="text-[0.85rem] md:text-[0.95rem] text-muted italic leading-relaxed max-w-[400px] mx-auto" data-id="element-27">
        {subtitle}
      </div>
    </div>;
}